// Tempo de exibição dos toasts. Mensagem de erro fica mais tempo na tela para
// dar tempo de ler e entender o que aconteceu (2026-10-01); os demais avisos
// mantêm o tempo de antes. A contagem pausa com o mouse sobre o toast (Radix).

/** Mensagens de erro (`variant: "destructive"`). */
export const ERROR_TOAST_DURATION_MS = 8000;
/** Demais toasts (sucesso, informação). */
export const DEFAULT_TOAST_DURATION_MS = 3000;

interface ToastTiming {
  variant?: string | null;
  duration?: number;
}

/** Tempo do toast: o informado na chamada prevalece; senão, pelo tipo. */
export function toastDurationFor({ variant, duration }: ToastTiming): number {
  if (duration !== undefined) return duration;
  return variant === 'destructive' ? ERROR_TOAST_DURATION_MS : DEFAULT_TOAST_DURATION_MS;
}
